import Stack from "@mui/material/Stack";
import ViewDatePicker from "../../view/View";

import React, {useState} from 'react';
import moment from 'moment'
import SelectDateControlled from "../selectDateFixed/selectDate/SelectDateControlled";
import {useTranslation} from "react-i18next";
import TabsCustom from "@ui/tabsCustom/TabsCustom";

const TabsDateStartEnd = ({
                              dateStart,
                              dateEnd,
                              onChangeDateStart,
                              onChangeDateEnd,
                              closeModalFn,
                              format,
                              initialTab,
                              hasTime = false,
                          }) => {

    const {t} = useTranslation()

    const [localeDateStart, setLocaleDateStart] = useState(moment(dateStart,format).format())
    const [localeDateEnd, setLocaleDateEnd] = useState(moment(dateEnd,format).format())

    const onSave = () => {
        onChangeDateStart(moment(localeDateStart)?.format(format))
        onChangeDateEnd(moment(localeDateEnd)?.format(format))
    }

    const tabs = [
        {
            component: <SelectDateControlled
                value={localeDateStart}
                onChange={setLocaleDateStart}
                label={t('dateStart')}
                closeModalFn={closeModalFn}
                onSave={onSave}
                hasTime={hasTime}
            />,
            label: t('dateStart'),
            index: 0,
        },
        {
            component: <SelectDateControlled
                value={localeDateEnd}
                onChange={setLocaleDateEnd}
                label={t('dateEnd')}
                format={format}
                closeModalFn={closeModalFn}
                onSave={onSave}
                hasTime={hasTime}
            />,
            label: t('dateEnd'),
            index: 1,
        },
    ]


    return (
        <ViewDatePicker>
            <Stack
                gap={1}
            >
                <TabsCustom
                    initial={initialTab}
                    tabs={tabs}
                />
            </Stack>

        </ViewDatePicker>
    );
};

export default TabsDateStartEnd;